<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">省份:</div>
                <el-select v-model="conditionData.province" @change="provinceChange">
                    <el-option :key="index" :label="item.label" :value="item.value" v-for="(item,index) in options"></el-option>
                </el-select>
                <!-- <el-cascader
                size="small"
                :options="options"
                v-model="conditionData.city"
                @change="handleRegionChange">
                </el-cascader> -->
            </div>
            <div class="item">
                <div class="label">城市:</div>
                <el-select v-model="conditionData.city">
                    <el-option :key="index" :label="item.label" :value="item.value" v-for="(item,index) in cityOptions"></el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="省份"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="城市"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="ybzc"
                label="医保政策" 
                >
                <!-- <template slot-scope="scope">
                    <div v-html="scope.row.ybzc">
                    </div>
                </template> -->

                <el-table-column
          prop="menzheng"
          label="门诊" width="230">
          <template slot-scope="scope" >
                    <div v-html="scope.row.menzheng">
                    </div>
                </template>
        </el-table-column>
                <el-table-column
          prop="menzhengbig"
          label="门诊大病" width="230">
          <template slot-scope="scope">
                    <div v-html="scope.row.menzhengbig">
                    </div>
                </template>
        </el-table-column>
        <el-table-column
          prop="zhuyuan"
          label="住院"
          width="300">
          <template slot-scope="scope">
                    <div v-html="scope.row.zhuyuan">
                    </div>
                </template>
        </el-table-column>
        <el-table-column
          prop="shengyu"
          label="生育"
          width="230">
          <template slot-scope="scope">
                    <div v-html="scope.row.shengyu">
                    </div>
                </template>
        </el-table-column>
        <el-table-column
          prop="yiwai"
          label="工伤（意外）"
          width="300">
          <template slot-scope="scope">
                    <div v-html="scope.row.yiwai">
                    </div>
                </template>
        </el-table-column>

                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:4,
            conditionData:{
                province:'',
                city:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[

                {
                    province:'广东省',
                    city:'广州',
                    menzheng:'职工医保：普通门诊待遇标准<br />'
                    +'　(1)起付标准 :无。<br />'
                    +'　(2)普通门诊统筹基金支付比例及最高支付限额：<br />'
                    +'<img src="https://imgbdb4.bendibao.com/gzbdb/gzsi/20232/22/2023222154204_75478.png" alt="" style="width:100%"/>'+'<br />'
                    +'城乡医保报销比例<br />'
                    +'普通门诊待遇标准<br />'
                    +'参保人在选定的定点医疗机构进行普通门诊就医，发生的属于广州市社会医疗保险普通门诊药品目录范围内的基本医疗药费由统筹基金按以下规定支付 :<br />'
                    +'<img src="https://imgbdb4.bendibao.com/gzbdb/life/20232/22/2023222155240_42861.png" alt="" style="width:100%"/>'+'<br />',
                    menzhengbig: '在城乡居民医保年度内，参保人员住院或进行门诊特定病种治疗发生的基本医疗费用，大病保险资金按以下标准支付：<br />'
                    +'（一）属于城乡居民医保统筹基金最高支付限额以下所对应的个人自付医疗费用，全年累计1.8万元以上（不含1.8万元）、3.6万元及以下部分，由大病保险资金支付60%；全年累计3.6万元以上、城乡居民医保统筹基金最高支付限额及以下部分，由大病保险资金支付75%。<br />'
                    +'　对享受本市医疗救助医疗费用减免待遇的参保人员，全年累计个人自付费用3500元以上（不含3500元）、城乡居民医保统筹基金最高支付限额及以下部分，由大病保险资金支付80%。<br />'
                    +'（二）全年累计超过城乡居民医保统筹基金最高支付限额以上的部分，由大病保险资金支付90%。<br />'
                    +'在一个城乡居民医保年度内，大病保险资金累计支付参保人员基本医疗费用的年度最高限额为40万元。连续参加本市城乡居民医保2年及以上的参保人员，大病保险资金年度最高支付限额提高至45万元。对享受本市医疗救助医疗费用减免待遇的参保人员，不设大病保险资金年度最高支付限额。<br />',
                    zhuyuan:'1.起付标准 (元)<br />'
                    +'定点医疗机构等级 在职职工/退休人员<br />'
                    +'一级 250<br />'
                    +'二级 500<br />'
                    +'三级 1000<br />'
                    +'　*连续住院情形治疗时间每超过90天需重新计算一次起付标准。在专科定点医疗机构连续住院治疗结核病的，每超过180天需重新计算一次起付标准。<br />'
                    +'  *参保人因精神病在本市精神病专科医疗机构或者指定综合性医疗机构精神病专科病区住院治疗的，起付标准为0元<br />'
                    +'2.统筹基金支付比例(注意事项）<br />'
                    +'1.参保人住院治疗符合出院标准但不按照规定出院的，自定点医疗机构医嘱出院日期之次日起发生的费用，职工基本医疗保险统筹基金不予支付。<br />'
                    +'2.参保人出院后因病情需要，符合入院标准可再入院治疗，与出院时间长短无关。<br />'
                    +'<img src="https://imgbdb4.bendibao.com/gzbdb/gzsi/20232/22/2023222154834_78718.png" alt="" style="width:100%"/>'+'<br />'
                    +'3.城乡医保报销比例：住院待遇标准，参保人每次住院基本医疗费用统筹基金的起付标准、共付段统筹基金支付比例为:<br />'
                    +'<img src="https://imgbdb4.bendibao.com/gzbdb/life/20232/22/2023222155745_72467.png" alt="" style="width:100%"/>'+'<br />',
                    shengyu:'职工应当享受的生育津贴，按照职工生育或者施行计划生育手术时用人单位上年度职工月平均工资除以30再乘以规定的假期天数计发。<br />'
                    +'在一个社会保险年度内，定点医疗机构为参保人提供优质医疗服务且无违反生育保险规定，参保人实际发生的生育医疗费用总额达到定额偿付总额90％以上的，由社会保险经办机构按定额标准全额偿付；未达到定额偿付总额90％的（不含90％），按实际费用额偿付。<br />'
                    +'参保人因急诊在非选定医疗机构就医、经批准在异地就医以及其他符合规定情形发生的生育医疗费用，可凭相关资料向社会保险经办机构申请报销。经审核后，属于符合规定的费用低于本市同等级定点医疗机构定额标准的，按实际报销；高于定额标准的，按定额标准报销。<br />'
                    +'　参保人已在选定医疗机构享受产前检查待遇的，只给予报销相应住院分娩费用，属于符合规定的实际住院分娩费用低于本市同等级定点医疗机构住院分娩费用定额标准的，按实际报销；高于定额标准的，按定额标准报销。<br />'
                    +'参保人参加本市生育保险累计缴费满1年、未办理就医确认手续或未按规定就医的，可在其分娩、人流、计划生育手术后1年内，由用人单位或参保人凭相关资料向社会保险经办机构申请支付一次性生育医疗费用补贴。补贴限额标准为本市同等级定点医疗机构相应定额标准的60％。<br />',
                    // +'在参加本市生育保险期间妊娠或施行计划生育手术但累计缴费未满1年的，可待其累计缴费满12个月后的1年内，由用人单位凭相关资料向社会保险经办机构申请报销，限额报销标准为本市同等级定点医疗机构相应定额标准的80％。<br />'
                    // +'未就业配偶只可享受本市生育医疗费用待遇，不享受生育津贴待遇。未就业配偶享受生育医疗费用的待遇标准，参照本市城乡居民基本医疗保险生育医疗待遇标准执行。具体标准如下：<br />'

                   yiwai:''
                    +'一级伤残<br />'
                    +'一次性伤残补助金=本人工资×27个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×90%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。<br />'
                    +'要求：保留劳动关系，退出工作岗位。工伤职工达到退休年龄并办理退休手续后，停发伤残津贴，享受基本养老保险待遇。基本养老保险待遇低于伤残津贴的，补足差额。用人单位和职工个人以伤残津贴为基数，缴纳基本医疗保险费。<br />'
                    +'二级伤残<br />'
                    +'一次性伤残补助金=本人工资×25个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×85%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。<br />'
                    +'要求：保留劳动关系，退出工作岗位。工伤职工达到退休年龄并办理退休手续后，停发伤残津贴，享受基本养老保险待遇。基本养老保险待遇低于伤残津贴的，补足差额。用人单位和职工个人以伤残津贴为基数，缴纳基本医疗保险费。<br />'
                    +'三级伤残<br />'
                    +'一次性伤残补助金=本人工资×23个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×80%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。'
                    +'要求：保留劳动关系，退出工作岗位。工伤职工达到退休年龄并办理退休手续后，停发伤残津贴，享受基本养老保险待遇。基本养老保险待遇低于伤残津贴的，补足差额。用人单位和职工个人以伤残津贴为基数，缴纳基本医疗保险费。<br />'
                    +'四级伤残<br />'
                    +'一次性伤残补助金=本人工资×21个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×75%<br />'


                },{
                    province:'广东省',
                    city:'深圳',
                    menzheng:'一档医保门诊统筹基金支付比例：<br />'
                    +'1.甲类药品、诊疗项目或医用耗材：一级以下医疗机构75%、二级医院65%、三级医院55%;<br />'
                    +'2.乙类药品：一级以下医疗机构70%、二级医院60%、三级医院50%;<br />'
                    +'退休人员支付比例提高5个百分<br />'
                    +'二、三档医保报销比例：<br />'
                    +'在选定的深圳市内定点社康中心就医，由社区门诊统筹基金支付，同一医保年度内的最高支付总额≤1000元<br />'
                    +'1.甲类药80%，乙类药60%;2.单项诊疗或材料90%，最高支付额≤120元。<br />',
                    menzhengbig:'深圳大病保险报销范围<br />'
                    +'参保人发生的下列医疗费用，纳入大病保险待遇享受范围：<br />'
                    +'(一)基本医疗保险统筹基金按照本办法规定支付的住院及门特病种基本医疗费用，超过基本医疗保险统筹基金年度支付限额以及门特病种支付限额的部分;<br />'
                    +'(二)参保人发生的住院及门特病种基本医疗费用中属于个人自付的基本医疗费用，但《深圳市医疗保障办法》第四十条第一款第二项、第三项基本医疗保险支付比例的降低部分除外;<br />'
                    +'(三)参保人在定点医疗机构门诊就医发生的国家谈判药品费用中属于个人自付的基本医疗费用;<br />'
                    +'(四)住院起付线以下费用;<br />'
                    +'(五)国家、广东省及本市规定的其他费用。<br />'
                    +'深圳大病报销报销比例<br />'
                    +'大病保险实行分段报销，目前大病保险起付线为1万元，在一个医保年度内符合上述保障范围内的费用，累计1万元以上3万元以下部分可报销70%;超过3万元以上部分报销80%。<br />'
                    +'<img src="https://txggpic.oss-cn-shenzhen.aliyuncs.com/20231220/20231220144713kR2AG" alt="" style="width:100%"/>'+'<br />',
                    zhuyuan:'市内住院报销比例<br />'
                    +'(一)职工医保一档参保人，在一级以下医院支付比例为94%，二级医院支付比例为92%，三级医院支付比例为90%;退休人员支付比例为95%;<br />'
                    +'(二)职工医保二档参保人，在一级以下医院支付比例为92%，二级医院支付比例为91%，三级医院支付比例为90%;退休人员支付比例为95%;<br />'
                    +'(三)居民医保参保人，在一级以下医院支付比例为92%，二级医院支付比例为91%，三级医院支付比例为90%;年满60周岁及以上的人员，支付比例为95%。<br />'
                    +'异地住院费用报销比例：参保人按规定办理异地就医备案手续后，可以享受异地就医直接结算服务，并按照下列规定享受待遇：<br />'
                    +'异地住院费用报销比例：参保人按规定办理异地就医备案手续后，可以享受异地就医直接结算服务，并按照下列规定享受待遇：<br />'
                    +'(二)参保人在异地急诊抢救的，在市外联网定点医疗机构直接结算的基本医疗费用支付比例按照市内就医支付比例的90%支付;<br />'
                    +'(三)其他临时外出就医的参保人，在市外联网定点医疗机构直接结算的基本医疗费用按照市内就医支付比例的80%支付，其中在省内异地联网定点医疗机构直接结算的住院基本医疗费用按照市内就医支付比例的90%支付。<br />'
                    +'异地住院起付线和深圳市内一样。',
                    shengyu:'A：生育医疗保险报销范围：<br />'
                    +'一、生育的医疗费用，即女职工在孕产期内因怀孕、分娩发生的医疗费用，包括符合国家和省规定的产前检查的费用，终止妊娠的费用，分娩住院期间的接生费、手术费、住院费、药费及诊治妊娠合并症、并发症的费用。'
                    +'二、计划生育的医疗费用，包括职工放置或者取出宫内节育器，施行输卵管、输精管结扎或者复通手术、人工流产、引产术等发生的医疗费用。<br />'
                    +'三、法律、法规、规章规定的其他项目费用<br />'
                    +'B:生育医疗费用一次性定额报销标准:<br />'
                    +'一、生育的医疗费用<br />'
                    +'1.产前检查：自确定妊娠至分娩，发生的产前检查费用按定额标准支付2600元；自确定妊娠至终止妊娠，发生的产前检查费用按实际发生的基本医疗费用支付，不超过2600元。<br />'
                    +'2.单胎顺产分娩：3200元;<br />'
                    +'3.单胎难产分娩(指臀位助产、臀位牵引、胎头吸引、胎头旋转、产钳助产)：5200元;<br />'
                    +'4.单胎剖宫产分娩：6000元;<br />'
                    +'5.多胞胎分娩：在相应分娩标准的基础上，每增加一胎增加1000元。<br />'
                    +'终止妊娠的医疗费用参照计划生育相应项目标准。<br />',
                    yiwai:'一级伤残<br />'
                    +'一次性伤残补助金=本人工资×27个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×90%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。<br />'
                    +'要求：保留劳动关系，退出工作岗位。工伤职工达到退休年龄并办理退休手续后，停发伤残津贴，享受基本养老保险待遇。基本养老保险待遇低于伤残津贴的，补足差额。用人单位和职工个人以伤残津贴为基数，缴纳基本医疗保险费。<br />'
                    +'二级伤残<br />'
                    +'一次性伤残补助金=本人工资×25个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×85%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。<br />'
                    +'要求：保留劳动关系，退出工作岗位。工伤职工达到退休年龄并办理退休手续后，停发伤残津贴，享受基本养老保险待遇。基本养老保险待遇低于伤残津贴的，补足差额。用人单位和职工个人以伤残津贴为基数，缴纳基本医疗保险费。<br />'
                    +'三级伤残<br />'
                    +'一次性伤残补助金=本人工资×23个月<br />'
                    +'按月享受伤残津贴(按月支付)=本人工资×80%<br />'
                    +'伤残津贴实际金额低于当地最低工资标准的，补足差额。<br />',

                },{
                    province:'湖南省',
                    city:'长沙市',
                    ybzc:'<strong>一、职工医保</strong><div></div>'
                    +'1、住院报销比例<div></div>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/20230510163938NfehW" alt="" style="width:600px;height:241px"/>'+'<div></div>'
                    +'2、门诊报销比例<div></div>'
                    +'①一级定点医疗机构及基层定点医疗卫生机构不设起付标准，按70%比例支付;<div></div>'
                    +'②二级定点医疗机构起付标准200元，按60%比例支付;<div></div>'
                    +'③三级定点医疗机构起付标准300元，按60%比例支付。<div></div>'
                    +'一个自然年度内，职工门诊统筹起付标准累计不超过300元，在职职工最高支付限额为1500元，退休人员最高支付限额为2000元，不计入职工医保年度最高支付限额。<div></div>'
                    +'<strong>二、居民医保</strong><div></div>'
                    +'1、门诊报销<div></div>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/20230510163941MCEpr" alt="" style="width:642px;height:338px"/>'+'<div></div>'

                    +'一个结算年度内发生的政策范围内门诊医疗费用最高支付限额为800元。<div></div>'
                    +'注意：城乡居民基本医疗保险普通门诊就医实行定点管理。<div></div>'
                    +'2、住院报销<div></div>'
                    +'一个结算年度内，城乡居民基本医疗保险（不含城乡居民大病保险）累计最高支付限额为15万元。<div></div>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/20230510163945ahnFb" alt="" style="width:600px;height:257px"/>'+'<div></div>'

                    +'3、生育医疗费用<div></div>'
                    +'城乡居民医保基金对参保居民符合计划生育政策规定的生育医疗费用(含产前检查费)给予一次性补助。<div></div>'
                    +'产前检查费最高补助标准为600元；平产最高补助标准为2000元；剖宫产最高补助标准为3000元。补助标准根据居民医保基金运行情况适时调整。孕产妇因高危重症救治发生的医疗费用，参照因疾病住院相关标准支付。<div></div>'

                },{
                    province:'广东省',
                    city:'深圳',
                    ybzc:'<strong>社区门诊报销比例:</strong>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/202305101639524biNe" alt="" style="width:432px;height:306px"/>'+'<div></div>'
                    +'<strong>特定门诊报销比例:</strong><div></div>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/20230510163955SZSDC" alt="" style="width:400px;height:268px"/>'+'<div></div>'
                    +'<strong>住院医疗报销比例:</strong><div></div>'
                    +'<img src="http://txggpic.oss-cn-shenzhen.aliyuncs.com/20230510/20230510163958s3RDp" alt="" style="width:432px;height:532px"/>'+'<div></div>'
                }

            ],

            addressList:[],
            options:provinceAndCityData,
            cityOptions:[],
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            list:[
                '化学药','生物制品','中成药','中药饮片'
            ],
        }
    },
    created(){
        

    },
    mounted(){
        console.log(provinceAndCityData);
        // this.loadingData();
    },
    methods:{
        provinceChange(e){
            console.log(e);
            for(let i in this.options){
                if(e==this.options[i].value){
                    this.conditionData.city='';
                    this.cityOptions = this.options[i].children;
                    return
                }
            }
        },
        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            // this.loadingData();
        },
        reset(){
            this.conditionData = {
                province:'',
                city:'',
                page:1,
                pageSize:10,
            };
            // this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 80px;
                margin-left: 15px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
#el-table__cell{
    vertical-align: top;
}
    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
